import React,{ useContext } from 'react'
import './Intro.css'
import resume from './Shashikanth_Mogilicherla_Associate_Consultant_Resume_React.pdf'
import { Container, Row, Col } from 'reactstrap'
import profile from '../../assets/profilepic.png'
import {themeContext} from '../../Context'

const Intro = () => {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode;
    return (
        <section className='hero__section mb-5' id='home'>
            <Container>
                <Row>
                    <Col lg='6' md='6'>
                        <div className="hero__content">
                            <h2 className='hero__tile'>I'm <span style={{fontWeight: 'bold'}}>Shashi Kanth</span></h2>
                            <p>
                                A highly talented and accomplished computer science professional with excellent knowledge of C
                                Programming Language, Software Development Life Cycle (SDLC), Oracle-JET, React Js, Angular, Javascript,
                                JAVA Technologies seeking an opportunity to pursue a career as a software developer. Highly interested
                                in working with React JS/Angular JS projects and looking forward for a platform where I can utilize my
                                knowledge in the best possible way that will help me enhance my skills with constant learning and contribution
                                towards the achievement of organizational goals. Able to learn any technology and flexible to work in Front
                                End/Back End technologies
                            </p>
                        </div>
                        <div className="hero__btn mt-4 d-flex align-items-center gap-4">
                            <button className={`btn ${darkMode ? 'hire__btn' : 'hire__btn_light'}`}>
                                <a href={resume} style={{ textDecoration: 'none' }} download>
                                    Download Resume
                                </a>
                            </button>
                        </div>
                    </Col>
                    <Col lg='6' md='6'>
                        <div className="hero__img">
                            <img src={profile} alt='' className='w-100' />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Intro